<template>
  <div>
    <v-row>
      <v-col xl="4" class="mb-3">
        <v-card class="target-display">
          <v-card-text vif="formattedData" class="d-flex justify-content-center">
            <div class="font-weight-bold">
              <div class="target-figures mb-2">
                <span class="large-number mr-1">{{ formattedData.num_routes_over_target }}</span>
                {{ $t('of') }}
                <span class="large-number mx-1">{{ formattedData.num_routes }}</span>
                {{ $t('routes_over_target' )}}
              </div>
              <div>Target: {{ formattedData.targetDiesel }}</div>
              <div>Average: {{ formattedData.averageDiesel }}</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col xl="8">
        <v-card
          no-body
          bg-variant="success"
          text-variant="white"
          class="impact-display font-weight-bold">
          <v-card-text v-if="formattedData">
            <h3 class="font-weight-bold">{{ $t('impact') }}</h3>
            <div class="d-flex justify-content-around">
              <div class="d-flex align-items-center">
                <v-icon>mdi-currency-usd</v-icon>
                <span>{{ formattedData.costOverTarget }}</span>
              </div>
              <div class="d-flex align-items-center">
                <v-icon>mdi-gas-station</v-icon>
                <span>{{ formattedData.dieselOverTarget }} </span>
              </div>
              <div class="d-flex align-items-center cursor-pointer" v-b-popover.top="carbonPopoverConfig">
                <v-icon>mdi-smog</v-icon>
                <span>{{ formattedData.totalCO2Emissions }}</span>
              </div>
            </div>
          </v-card-text>
        </v-card>

      </v-col>
    </v-row>
  </div>
</template>

<script>
import SustainabilityMixin from '@/components/mixins/SustainabilityMixin'

export default {
  name: 'EnrouteMetricsSummary',
  mixins: [
    SustainabilityMixin
  ],
  props: {
    metricsData: null,
    loading: null
  },
  computed: {
    /**
     * Get the data from the metricsData prop. I am assuming we are just showing one customer here (since we have to
     * display the target data), so we don't need to sum it up, we can just return the first value available.
     * @returns {*}
     */
    formattedData () {
      if (this.metricsData) {
        const metricsData = this.metricsData
        const format = (x, label) => this.$n(x) + ' ' + this.$tc(label, x)
        const dieselOverTarget = this.convertDieselFromLiters(metricsData.power_diesel_over_target_l, 1)

        return {
          num_routes: this.$n(metricsData.num_routes),
          num_routes_over_target: this.$n(metricsData.num_routes_over_target),
          targetDiesel: metricsData.power_diesel_target_pct + '%',
          averageDiesel: metricsData.power_diesel_pct_avg + '%',
          costOverTarget: this.formatCurrency(dieselOverTarget * this.sustainabilityParams.dieselPrice),
          dieselOverTarget: format(dieselOverTarget, this.dieselUnitLabel),
          totalCO2Emissions: format(this.getCO2Emissions(metricsData.power_diesel_over_target_l, 1), this.weightFormatLabel)
        }
      }
      return null
    },
    carbonPopoverConfig () {
      const trees = this.$n(this.getTreesEstimate(this.metricsData.power_diesel_over_target_l))
      const flights = this.$n(this.getFlightsEstimate(this.metricsData.power_diesel_over_target_l))
      return {
        html: true,
        customClass: 'carbon-popover',
        content: () => {
          return `
            <div class="d-flex">
              <div>
                <span class="popover-figure mr-5">${trees}</span><br>Trees
              </div>
              <div>
                <span class="popover-figure">${flights}</span><br>Domestic Flights
              </div>
            </div>
          `
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/colors.scss";

.target-display {
  background: linear-gradient(180deg, rgba(255, 255, 255,1) 0%, rgba(220, 220, 220, 1) 85%);
  border-color: gray;
  font-size: 1.3rem;
  color: #032f33;
  min-height: 9rem;
}
.impact-display {
  background: linear-gradient(180deg, rgba(124, 222, 124, 1) 0%, rgba(92, 184, 92, 1) 85%);
  font-size: 1.8rem;
  min-height: 9rem;
}
.target-figures {
  font-size: 1.2rem;
  .large-number {
    font-size: 1.5rem;
  }
}
.carbon-popover {
}
.carbon-popover ::v-deep(.popover-figure) {
  font-weight: bold;
  font-size: 1.5rem;
  line-height: 1.6rem;
}
.carbon-popover ::v-deep(.popover-body) {
  color: green;
}
</style>
